import axiosInstance from "../axiosInstance";
const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const getOvertimeApi = async (payload: any) => {
  try {
    console.log("PA", payload);

    const response = await axiosInstance.get(
      BASE_URL +
        `v1/${STAGE}/dashboard/overtimes/?startdate=${payload.stardate}&enddate=${payload.enddate}`
    );
    console.log("RA", response.data);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const approveAllOvertimeApi = async () => {
  try {
    const response = await axiosInstance.put(
      BASE_URL + `v1/${STAGE}/dashboard/overtimes`
    );
    console.log("RA", response.data);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
